/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { Form, Button } from 'antd';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import AntdTextField from '../../../common/antd-form-components/AntdTextField';
import SettingsMeasurementUnitsContext from '../../../contexts/settings-contexts/SettingsMeasurementUnitsPage';
import AntdTextarea from '../../../common/antd-form-components/AntdTextarea';
import addNewUnitApi from '../../../apis/settings-apis/measuremnet-units-apis/addNewUnitApi';
import successNotification from '../../../utils/successNotification';
import errorNotification from '../../../utils/errorNotification';
import UserContext from '../../../contexts/user-context/UserProvider';
import useCustomApiRequest from '../../../custom-hooks/useCustomApiRequest';
import checkRes from '../../../utils/checkRes';
import StoreVariantsContext from '../../../contexts/store-variants/VariantsContextPage';
import addNewVariantApi from '../../../apis/store-apis/variants-apis/addNewVariantApi';
import { useTranslation } from 'react-i18next';

const TableForm = () => {
  const { user } = useContext(UserContext);
  const {
    selectedUnit,
    setIsLoading,
    setModalOpened,
    setFetchCount,
    isSubmittingForm,
    setIsSubmittingForm
  } = useContext(StoreVariantsContext);
  const { t } = useTranslation();

  const customApiRequest = useCustomApiRequest();
  const schema = Yup.object().shape({
    unit_variant: Yup.string()
      .required(t('Inventory.VariantsTypes.nameTypeVariant'))
      .max('100', t('Inventory.Products.maxProductNameLength'))
  });
  const {
    control,
    setValue,
    handleSubmit,
    formState: { errors, isSubmitting }
  } = useForm({
    resolver: yupResolver(schema),
    mode: 'all',
    defaultValues: {
      unit_variant: ''
      // unit_note: ''
    }
  });

  const onSubmit = async (data) => {
    setIsSubmittingForm(true);
    setIsLoading(true);
    if (selectedUnit) {
      customApiRequest(
        addNewVariantApi(
          user?.token,
          {
            ...data,
            id: selectedUnit.id
          },
          true
        ),
        (res) => {
          setIsSubmittingForm(false);
          setIsLoading(false);
          if (checkRes(res) && res?.data?.data) {
            setModalOpened(false);
            setFetchCount((prevState) => prevState + 1);
            successNotification({
              title: t('Inventory.VariantsTypes.addedSuccessfully'),
              message: t('Inventory.VariantsTypes.variantModifiedSuccessfully')
            });
            setIsLoading(false);
          } else {
            setIsLoading(false);
            errorNotification({
              title: t('Inventory.VariantsTypes.errorOccurred'),
              message: res?.data?.message
                ? res.data.message
                : t('Inventory.VariantsTypes.pleaseTryLater')
            });
            setIsSubmittingForm(false);
          }
        },
        (error) => {
          setIsSubmittingForm(false);
          setIsLoading(false);
          errorNotification({
            title: t('Inventory.VariantsTypes.errorOccurred'),
            message:
              error?.response?.data?.message ||
              t('Inventory.VariantsTypes.pleaseTryLater')
          });
        }
      );
    } else {
      customApiRequest(
        addNewVariantApi(user?.token, data),
        (res) => {
          setIsLoading(false);
          setIsSubmittingForm(false);
          if (res?.status === 200 && res?.data?.data) {
            setModalOpened(false);
            setFetchCount((prevState) => prevState + 1);
            successNotification({
              title: t('Inventory.VariantsTypes.addedSuccessfully'),
              message: t('Inventory.VariantsTypes.variantAddedSuccessfully')
            });
          } else {
            setIsLoading(false);
            setIsSubmittingForm(false);

            errorNotification({
              title: t('Inventory.VariantsTypes.errorOccurred'),
              message: res?.data?.message
                ? res.data.message
                : t('Inventory.VariantsTypes.pleaseTryLater')
            });
          }
        },
        (error) => {
          setIsLoading(false);
          setIsSubmittingForm(false);
          errorNotification({
            title: t('Inventory.VariantsTypes.errorOccurred'),
            message:
              error?.response?.data?.message ||
              t('Inventory.VariantsTypes.pleaseTryLater')
          });
        }
      );
    }
  };

  // handle initial values
  useEffect(() => {
    if (selectedUnit) {
      setValue('unit_variant', selectedUnit?.name ? selectedUnit.name : '');
    }
    // if (selectedUnit) {
    //   setValue('unit_note', selectedUnit?.note ? selectedUnit.note : '');
    // }
  }, [selectedUnit, selectedUnit?.id]);

  const [form] = Form.useForm();
  return (
    <Form
      className="custom-shared-form"
      form={form}
      layout="vertical"
      onFinish={handleSubmit(onSubmit)}
    >
      <div className="form-body">
        <div className="text-field-label-wrap">
          <p className="label-p">
            {t('Inventory.VariantsTypes.nameTypeVariant')}
          </p>
          <div className="text-field-wrap">
            <AntdTextField
              className="form-text-field"
              name="unit_variant"
              type="text"
              placeholder={t(
                'Inventory.VariantsTypes.nameTypeVariantPlaceholder'
              )}
              errorMsg={errors?.unit_variant?.message}
              validateStatus={errors?.unit_variant ? 'error' : ''}
              control={control}
            />
          </div>
        </div>

        {/* <div className="text-field-label-wrap">
          <p className="label-p">ملاحظات</p>
          <div className="text-field-wrap">
            <AntdTextarea
              className="form-text-area"
              name="unit_note"
              rows={8}
              placeholder="ملاحظات..."
              errorMsg={errors?.unit_note?.message}
              validateStatus={errors?.unit_note ? 'error' : ''}
              control={control}
            />
          </div>
        </div> */}

        <Button
          className="submit-btn"
          htmlType="submit"
          type="primary"
          // icon={<LoginOutlined />}
          loading={isSubmittingForm}
        >
          {selectedUnit
            ? t('Inventory.VariantsTypes.edit')
            : t('Inventory.VariantsTypes.add')}
        </Button>
      </div>
    </Form>
  );
};

export default TableForm;
